module.exports = __webpack_public_path__ + "img/magic_touch.9ec8c574.svg";